import React from 'react';
import NewPerson from './NewPerson';
import { IconChevronRight } from '../../Icons';
import Grid from '@material-ui/core/Grid/Grid';
import ButtonIcon from '../../components/ButtonIcon';
import Typography from '@material-ui/core/Typography/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import SelectPerson from '../People/SelectPerson';
import _Helper from '../../_Helper';
import Tabs from '@material-ui/core/Tabs/Tabs';
import Tab from '@material-ui/core/Tab/Tab';
import AppBar from '@material-ui/core/AppBar/AppBar';

const styles = {
    panelHeader: {
        backgroundColor: '#efefef',
        borderTopWidth: 1,
        borderTopColor: '#ddd',
        borderTopStyle: 'solid',
    },
};

class CreatePin extends React.Component {
    state = {
        tabIndex: 0,
        pinOwner: this.props.pinOwner,
    };

    tabSwitched = (event, value) => {
        this.setState({
            tabIndex: value,
        });
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!_Helper.isSameObject(nextProps.pinOwner, prevState.pinOwner)) {
            return {
                pinOwner: nextProps.pinOwner,
            };
        }
        return null;
    }

    render() {
        const {
            // classes,
            preventNext,
            goNext,
            pin,
            personSelected,
        } = this.props;
        const { tabIndex } = this.state;

        return (
            <div style={{ backgroundColor: '#fff', padding: 4 }}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={tabIndex}
                        onChange={this.tabSwitched}
                        indicatorColor="primary"
                        textColor="primary"
                        fullWidth
                    >
                        <Tab label="New Person" />
                        <Tab label="Select Person" />
                    </Tabs>
                </AppBar>
                {tabIndex === 0 && (
                    <TabContainer>
                        <NewPerson personAdded={personSelected} />
                    </TabContainer>
                )}
                {tabIndex === 1 && (
                    <TabContainer>
                        <SelectPerson
                            label="Select owner of pin"
                            onSelected={personSelected}
                        />
                    </TabContainer>
                )}
                <Grid style={{ paddingTop: 18 }} container>
                    <Grid item>
                        <Typography variant="body2">New PIN: {pin} </Typography>
                        <Typography variant="body2">
                            Owner of Pin: { this.state.pinOwner.name }
                        </Typography>
                    </Grid>
                    <Grid style={{ marginLeft: 'auto' }} item>
                        <ButtonIcon
                            onTap={goNext}
                            disabled={preventNext}
                            label="Next"
                            iconRight={<IconChevronRight />}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }
}
export default withStyles(styles)(CreatePin);

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}
